import { onCLS, onFCP, onINP, onLCP, onTTFB } from 'web-vitals'

/**
 * Report Core Web Vitals to whoever's listening.
 *
 * Sends:
 *  - Sentry (`Sentry.metrics`) if configured
 *  - `console.log` in dev for quick visibility
 *
 * Add additional sinks here (Posthog, BigQuery, etc.) without touching call sites.
 */
export function startWebVitals() {
  const sink = (name: string) => (metric: { value: number; rating: string }) => {
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.log(`[web-vitals] ${name}=${metric.value.toFixed(2)} (${metric.rating})`)
    }
  }
  onCLS(sink('CLS'))
  onFCP(sink('FCP'))
  onINP(sink('INP'))
  onLCP(sink('LCP'))
  onTTFB(sink('TTFB'))
}
